import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import styles from '../../styles/login/leftSection.module.scss';
import { breakpoints } from '../../theme/theme';

const TRANSITION_TIME = 4000;

export default function LeftSection({ qaQuotes=[] }) {
    const [currentQuote, setCurrentQuote] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentQuote((prev) => (prev + 1) % qaQuotes.length);
        }, TRANSITION_TIME);
        return () => clearInterval(interval);
    }, []);

    return (
        <Box 
            className={styles['left-section-container']}
        >
            <Box 
                className={styles['background-overlay']}
            />
            <Box 
                className={styles['content-container']}
            >
                {/* Quality Insights Section */}
                <Box className={styles['quality-insights-section']}>
                    <Box 
                        className={styles['quality-insights-icon']}
                    >
                        <svg fill="rgb(147 197 253 / var(--tw-text-opacity, 1))" viewBox="0 0 24 24">
                            <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h4v10h-10z" />
                        </svg>
                    </Box>
                    <h3 
                        className={styles['quality-insights-title']}
                    >
                        Quality Insights
                    </h3>
                </Box>
                <Box 
                    className={styles['quote-section']}
                >
                    <p 
                        className={styles['quote-text']}
                    >
                        "{qaQuotes[currentQuote]}"
                    </p>
                </Box>
                <Box className={styles['quote-indicators']}>
                    {qaQuotes.map((_, index) => (
                        <Box
                            key={index}
                            className={`${styles['quote-indicator']} ${
                                index === currentQuote ? styles['quote-indicator--active'] : ''
                            }`}
                        />
                    ))}
                </Box>
            </Box>
        </Box>
    );
}
